import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  dashboardData:[],
  updatedTime:0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getHarvest = createAsyncThunk(
  "farmer/harvest",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/farmer/harvest", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getHarvestById = createAsyncThunk(
  "farmer/harvest/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/farmer/harvest/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortHarvest = createAsyncThunk(
  "farmer/harvest/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/farmer/harvest/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postHarvest = createAsyncThunk(
  "farmer/harvest/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/farmer/harvest", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteHarvest = createAsyncThunk(
  "farmer/harvest/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/farmer/harvest/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateHarvest = createAsyncThunk(
  "farmer/harvest/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/farmer/harvest/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const harvestSlice = createSlice({
  name: "Harvest Store",
  initialState: initialState,
  reducers: {
    addHarvest(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortHarvest(state, action) {
      state.data.docs = action.payload;
    },
    deleteHarvest(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editHarvest(state, action) {
      let x = state.data.docs.findIndex((item) => item._id === action.payload._id);
      state.data.docs[x] = action.payload;
    },
    addDashboardData(state, action){
      state.dashboardData = action.payload;
    }
  },
  extraReducers: {
    [getHarvest.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getHarvest.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getHarvest.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getHarvestById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getHarvestById.fulfilled]: (state, action) => {
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getHarvestById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortHarvest.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortHarvest.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortHarvest.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postHarvest.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postHarvest.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postHarvest.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteHarvest.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteHarvest.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteHarvest.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateHarvest.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateHarvest.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateHarvest.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const harvestActions = harvestSlice.actions;

export default harvestSlice.reducer;
